/* Schachatelier – Gravur & Verpackung (sa-personalisierung) */
(() => {
  if (window.__saP) return;
  window.__saP = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // 14.10.2026: iki hediye kutusu – GGS urunleri 'geschenkbox-ggs' (5 EUR), digerleri 'geschenkbox' (9,99 EUR)
  const GIFT_HANDLES = ['geschenkbox', 'geschenkbox-ggs'];
  const isGift = (i) => GIFT_HANDLES.indexOf(i.handle) > -1;

  const EB_ITALIC = { name: 'EB Garamond Italic', css: '"EB Garamond", serif', weight: 500, italic: true };
  const FONTS = [
    EB_ITALIC,
    { name: 'Spectral', css: '"Spectral", serif', weight: 400 },
    { name: 'Cormorant Garamond', css: '"Cormorant Garamond", serif', weight: 600 },
    { name: 'Playfair Display', css: '"Playfair Display", serif', weight: 500 },
    { name: 'Cinzel', css: '"Cinzel", serif', weight: 500 },
    { name: 'Dancing Script', css: '"Dancing Script", cursive', weight: 500 },
    { name: 'Alex Brush', css: '"Alex Brush", cursive', weight: 400 }
  ];
  const SUNRISE_FONT = EB_ITALIC; // 23.09.2026: tum urunlerde varsayilan EB Garamond Italic
  const ALLOWED = /^[A-Za-z0-9 ÄÖÜäöüßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùûÿĞğİıŞş+&\-.,'!?]$/u;

  const T = {
    de: { engraving: 'Kostenlose Gravur', placeholder: 'Z. B.: Olivia', ph1: 'Z. B.: Olivia & Max', ph2: 'Z. B.: 12.09.2026', ph3: 'Z. B.: Berlin', line: 'Zeile', font: 'Gravurstil', sample: 'Ihr Text hier', note: 'Die Vorschau dient der Orientierung – jede Gravur wird von Hand ausgeführt.', packaging: 'Verpackung', standard: 'Standardverpackung', included: 'inklusive', gift: 'Geschenkbox', free: 'kostenlos', giftNote: 'Edle Geschenkverpackung für Ihre Liebsten.', allowed: "Erlaubt sind Buchstaben, Zahlen und + & - . , ' ! ?", limit: 'Maximal {n} Zeichen pro Zeile.', zoom: 'Vorschau vergrößern', close: 'Schließen' },
    en: { engraving: 'Free engraving', placeholder: 'e.g. Olivia', ph1: 'e.g. Olivia & Max', ph2: 'e.g. 12.09.2026', ph3: 'e.g. Berlin', line: 'Line', font: 'Engraving style', sample: 'Your text here', note: 'Preview for guidance only – every engraving is finished by hand.', packaging: 'Packaging', standard: 'Standard packaging', included: 'included', gift: 'Gift box', free: 'free', giftNote: 'Elegant gift packaging for your loved ones.', allowed: "Allowed: letters, numbers and + & - . , ' ! ?", limit: 'Maximum of {n} characters per line.', zoom: 'Enlarge preview', close: 'Close' },
    fr: { engraving: 'Gravure offerte', placeholder: 'p. ex. Olivia', ph1: 'p. ex. Olivia & Max', ph2: 'p. ex. 12.09.2026', ph3: 'p. ex. Berlin', line: 'Ligne', font: 'Style de gravure', sample: 'Votre texte ici', note: 'Aperçu indicatif – chaque gravure est réalisée à la main.', packaging: 'Emballage', standard: 'Emballage standard', included: 'inclus', gift: 'Coffret cadeau', free: 'offert', giftNote: 'Un emballage cadeau raffiné pour vos proches.', allowed: "Autorisés : lettres, chiffres et + & - . , ' ! ?", limit: '{n} caractères maximum par ligne.', zoom: "Agrandir l'aperçu", close: 'Fermer' },
    tr: { engraving: 'Ücretsiz gravür', placeholder: 'Örn.: Olivia', ph1: 'Örn.: Olivia & Max', ph2: 'Örn.: 12.09.2026', ph3: 'Örn.: Berlin', line: 'Satır', font: 'Gravür stili', sample: 'Metniniz burada', note: 'Önizleme fikir vermek içindir – her gravür elde işlenir.', packaging: 'Paketleme', standard: 'Standart kutu', included: 'dahil', gift: 'Hediye kutusu', free: 'ücretsiz', giftNote: 'Sevdikleriniz için şık hediye paketi.', allowed: "İzin verilenler: harfler, rakamlar ve + & - . , ' ! ?", limit: 'Satır başına en fazla {n} karakter.', zoom: 'Önizlemeyi büyüt', close: 'Kapat' }
  };
  const LANG = ((document.documentElement.lang || 'de').slice(0, 2) || 'de').toLowerCase();
  const t = (k) => (T[LANG] || T.de)[k];

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const newLink = () => 'sa' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

  /* ------------------------------------------------------------------ */
  /* Cart: gift box is added right before the main product, and kept in  */
  /* sync with it (same quantity; removed when the main item is gone).   */
  /* ------------------------------------------------------------------ */
  const origFetch = window.fetch.bind(window);
  const pending = {}; // link -> gift variant id

  function bodyParam(body, key) {
    try {
      if (!body) return null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.get(key);
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.get(key);
      if (typeof body === 'string') {
        const s = body.trim();
        if (s.charAt(0) === '{') {
          const j = JSON.parse(s);
          const it = (j.items && j.items[0]) || j;
          if (key === 'quantity') return it.quantity;
          const m = key.match(/^properties\[(.+)\]$/);
          return m && it.properties ? it.properties[m[1]] : null;
        }
        return new URLSearchParams(s).get(key);
      }
    } catch (e) {}
    return null;
  }

  window.fetch = function (input, init) {
    let url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    const isChange = /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);

    if (isAdd && init && init.body) {
      const link = bodyParam(init.body, 'properties[_sa_link]');
      if (link && pending[link]) {
        const variant = pending[link];
        delete pending[link];
        const qty = parseInt(bodyParam(init.body, 'quantity'), 10) || 1;
        document.dispatchEvent(new CustomEvent('sa:link-used', { detail: { link } }));
        return origFetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant, quantity: qty, properties: { _sa_link: link } }] })
        }).catch(() => null).then(() => origFetch(input, init));
      }
    }

    const res = origFetch(input, init);
    if (isChange) res.then(() => scheduleSync(), () => {});
    return res;
  };

  let syncTimer = null;
  let syncing = false;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCart, 350);
  }

  async function syncCart() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await origFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const mainQty = {};
      cart.items.forEach((i) => {
        const l = i.properties && i.properties._sa_link;
        if (l && !isGift(i)) mainQty[l] = (mainQty[l] || 0) + i.quantity;
      });
      const updates = {};
      const seen = {};
      let changed = false;
      cart.items.forEach((i) => {
        if (!isGift(i)) return;
        const l = i.properties && i.properties._sa_link;
        let want = l && !seen[l] ? mainQty[l] || 0 : 0;
        if (l) seen[l] = true;
        if (i.quantity !== want) { updates[i.key] = want; changed = true; }
      });
      // Gift box lines that will still exist after the updates
      const giftAlive = {};
      cart.items.forEach((i) => {
        if (!isGift(i)) return;
        const l = i.properties && i.properties._sa_link;
        const q = Object.prototype.hasOwnProperty.call(updates, i.key) ? updates[i.key] : i.quantity;
        if (l && q > 0) giftAlive[l] = true;
      });
      // Main lines whose gift box was removed -> switch back to standard packaging
      const orphanMains = cart.items.filter((i) => {
        const l = i.properties && i.properties._sa_link;
        return !isGift(i) && l && !giftAlive[l];
      });
      if (Object.keys(updates).length) {
        await origFetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
      for (const i of orphanMains) {
        const props = Object.assign({}, i.properties);
        delete props._sa_link;
        if (Object.prototype.hasOwnProperty.call(props, 'Packaging')) props.Packaging = 'Standard';
        await origFetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: i.key, quantity: i.quantity, properties: props })
        });
        changed = true;
      }
      if (changed) {
        if (/\/cart\/?$/.test(location.pathname)) {
          location.reload();
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      }
    } catch (e) {
    } finally {
      syncing = false;
    }
  }

  if (/\/cart\/?$/.test(location.pathname)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCart);
    else syncCart();
  }

  /* ------------------------------------------------------------------ */
  /* Product page block                                                  */
  /* ------------------------------------------------------------------ */
  function sanitize(raw, limit) {
    const normalized = raw.replace(/[’‘`´]/g, "'").normalize('NFC');
    let removed = false;
    let out = '';
    for (const ch of Array.from(normalized)) {
      if (ALLOWED.test(ch)) out += ch; else removed = true;
    }
    out = out.replace(/ {2,}/g, ' ').replace(/^ +/, '');
    let cut = false;
    if (Array.from(out).length > limit) { out = Array.from(out).slice(0, limit).join(''); cut = true; }
    return { out, removed, cut };
  }

  function findTarget() {
    return document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
  }

  function init(root) {
    if (root.__saInit) return;
    const target = findTarget();
    if (!target) return;
    const form = target.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    root.__saInit = true;
    // The form's .id property is shadowed by its <input name="id">, so read the attribute instead.
    if (!form.getAttribute('id')) form.setAttribute('id', 'sa-form-' + Math.random().toString(36).slice(2));
    const formId = form.getAttribute('id');

    let cfg;
    try { cfg = JSON.parse(root.querySelector('[data-sa-config]').textContent); } catch (e) { return; }

    const mode = cfg.mode; // ggs | sunrise | none
    const lines = mode === 'none' ? 0 : cfg.lines === 3 ? 3 : 1;
    const limit = cfg.limit || (lines === 3 ? 20 : 30);
    const hasGift = !!(cfg.giftVariant && cfg.giftAvailable);
    const pv = mode !== 'none' ? cfg.preview : null;
    if (!lines && !hasGift) return;

    const st = { texts: new Array(lines).fill(''), font: FONTS[0], pack: 'standard', link: null };
    const currentFont = () => (mode === 'sunrise' ? SUNRISE_FONT : st.font);
    const filled = () => st.texts.map((s) => s.trim().replace(/ {2,}/g, ' ')).filter(Boolean);

    /* ---- markup ---- */
    const chevron = '<svg width="14" height="9" viewBox="0 0 14 9" aria-hidden="true"><path d="M1 1.5l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    const giftIcon = '<svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20 7h-2.2A3 3 0 0 0 12 3.8 3 3 0 0 0 6.2 7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8h.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm-6-1.5a1.5 1.5 0 1 1 1.5 1.5H14Zm-5.5 0A1.5 1.5 0 0 1 10 5.5V7H8.5a1.5 1.5 0 0 1 0-1.5ZM11 20H6.5v-8H11Zm0-9.5H4.5V8.5H11Zm6.5 9.5H13v-8h4.5Zm1-9.5H13V8.5h6.5Z"/></svg>';
    const uid = 'sa' + Math.random().toString(36).slice(2, 8);
    let html = '';
    if (lines) {
      const single = mode !== 'ggs' || lines === 3;
      html += '<div class="sa-p__row' + (single ? ' sa-p__row--single' : '') + '">' +
        '<div class="sa-p__field"><span class="sa-p__label">' + esc(t('engraving')) + '</span><div data-sa-lines></div></div>';
      if (mode === 'ggs') {
        html += '<div class="sa-p__field" data-sa-fontfield><span class="sa-p__label" id="' + uid + '-fl">' + esc(t('font')) + '</span>' +
          '<button type="button" class="sa-p__select" data-sa-fontbtn aria-haspopup="listbox" aria-expanded="false" aria-labelledby="' + uid + '-fl ' + uid + '-fv">' +
          '<span class="sa-p__select-value" id="' + uid + '-fv" data-sa-fontval></span>' + chevron + '</button>' +
          '<ul class="sa-p__list" role="listbox" tabindex="-1" hidden data-sa-fontlist></ul></div>';
      }
      html += '</div><p class="sa-p__msg" aria-live="polite" data-sa-msg></p>';
      if (pv) {
        html += '<div class="sa-p__prev"><button type="button" class="sa-p__stage" data-sa-stage aria-label="' + esc(t('zoom')) + '"><canvas data-sa-canvas></canvas>' +
          '<span class="sa-p__zoom" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 14 14"><path d="M8.5 1H13v4.5M13 1L8 6M5.5 13H1V8.5M1 13l5-5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></span></button>' +
          '<p class="sa-p__note">' + esc(t('note')) + '</p></div>';
      }
    }
    if (hasGift) {
      const priceLabel = Number(cfg.giftPrice) === 0 ? t('free') : '+ ' + cfg.giftPriceLabel;
      html += '<div class="sa-p__pack"><span class="sa-p__label" id="' + uid + '-pl">' + esc(t('packaging')) + '</span>' +
        '<div class="sa-p__opts" role="radiogroup" aria-labelledby="' + uid + '-pl">' +
        '<button type="button" class="sa-p__opt" role="radio" aria-checked="true" data-sa-pack="standard"><span class="sa-p__opt-t">' + esc(t('standard')) + '</span><span class="sa-p__opt-pr">' + esc(t('included')) + '</span></button>' +
        '<button type="button" class="sa-p__opt" role="radio" aria-checked="false" data-sa-pack="gift"><span class="sa-p__opt-t">' + giftIcon + esc(t('gift')) + '</span><span class="sa-p__opt-pr">' + esc(priceLabel) + '</span></button>' +
        '</div><p class="sa-p__sub">' + esc(t('giftNote')) + '</p></div>';
    }
    html += '<div hidden data-sa-props></div>';

    const body = document.createElement('div');
    body.innerHTML = html;
    root.appendChild(body);

    const $ = (sel) => root.querySelector(sel);
    const propsBox = $('[data-sa-props]');
    const msg = $('[data-sa-msg]');
    const canvas = $('[data-sa-canvas]');
    const stage = $('[data-sa-stage]');

    /* ---- hidden line item properties (linked to the product form) ---- */
    function setProps() {
      propsBox.innerHTML = '';
      const add = (k, v) => {
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'properties[' + k + ']';
        i.value = v;
        i.setAttribute('form', formId);
        propsBox.appendChild(i);
      };
      const fl = filled();
      if (lines && fl.length) {
        if (lines === 1) add('Engraving', fl[0]);
        else fl.forEach((l, i) => add('Engraving line ' + (i + 1), l));
        add('Font', currentFont().name);
      }
      if (hasGift) add('Packaging', st.pack === 'gift' ? 'Gift box' : 'Standard');
      if (st.pack === 'gift') {
        if (!st.link) { st.link = newLink(); pending[st.link] = cfg.giftVariant; }
        add('_sa_link', st.link);
      }
    }
    /* ---- express checkout (Shop Pay etc.) with gift box: add both items, then go to checkout ---- */
    const dyn = form.querySelector('.shopify-payment-button');
    if (dyn) {
      dyn.addEventListener('click', (e) => {
        if (st.pack !== 'gift' || !hasGift) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        setProps();
        const fd = new FormData(form);
        const link = fd.get('properties[_sa_link]');
        const qty = parseInt(fd.get('quantity'), 10) || 1;
        if (link) { delete pending[link]; st.link = null; }
        origFetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: cfg.giftVariant, quantity: qty, properties: { _sa_link: link } }] })
        })
          .then(() => origFetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }))
          .then((r) => { if (!r.ok) throw new Error('add failed'); location.href = ROOT + 'checkout'; })
          .catch(() => { scheduleSync(); location.href = ROOT + 'cart'; });
      }, true);
    }
    document.addEventListener('sa:link-used', (e) => {
      if (e.detail && e.detail.link === st.link) { st.link = null; setProps(); }
    });

    /* ---- messages ---- */
    let msgTimer;
    function flash(text, ms) {
      if (!msg) return;
      clearTimeout(msgTimer);
      msg.textContent = text;
      msgTimer = setTimeout(() => { msg.textContent = ''; }, ms || 3200);
    }

    /* ---- preview ---- */
    let img = null;
    let imgReady = false;
    if (pv && pv.img) {
      img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => { imgReady = true; render(); };
      img.src = pv.img;
    }

    function draw(cv, displayWidth) {
      if (!cv || !imgReady) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const W = Math.max(1, Math.round(displayWidth * dpr));
      const H = Math.round(W * img.naturalHeight / img.naturalWidth);
      cv.width = W; cv.height = H;
      const g = cv.getContext('2d');
      g.drawImage(img, 0, 0, W, H);
      const x = pv.x / 100 * W, y = pv.y / 100 * H, w = pv.w / 100 * W, h = pv.h / 100 * H;

      let txt = filled();
      let ghost = false;
      if (!txt.length) {
        const s = t('sample');
        txt = lines === 1 ? [s] : [s + ' 1', s + ' 2', s + ' 3'];
        ghost = true;
      }
      const f = currentFont();
      const style = (f.italic ? 'italic ' : '') + (f.weight || 400) + ' ';
      const slotH = h / lines;
      let size = slotH * (lines === 1 ? 0.64 : 0.74);
      g.font = style + size + 'px ' + f.css;
      const widest = Math.max.apply(null, txt.map((l) => g.measureText(l).width));
      if (widest > w * 0.9) size *= (w * 0.9) / widest;
      g.font = style + size + 'px ' + f.css;
      const lh = lines === 1 ? 0 : Math.min(slotH, size * 1.25);
      const top = -lh * (txt.length - 1) / 2;

      g.save();
      g.translate(x + w / 2, y + h / 2);
      g.rotate((pv.angle || 0) * Math.PI / 180);
      g.textAlign = 'center';
      g.textBaseline = 'middle';
      if (ghost) g.globalAlpha = 0.5;
      txt.forEach((line, j) => {
        const ly = top + j * lh;
        if (pv.color === 'light') {
          g.fillStyle = 'rgba(0,0,0,.45)'; g.fillText(line, 0, ly + size * 0.035);
          g.fillStyle = '#E9D6AE'; g.fillText(line, 0, ly);
        } else {
          g.globalCompositeOperation = 'source-over';
          g.fillStyle = 'rgba(255,238,205,.35)'; g.fillText(line, 0, ly + size * 0.035);
          g.globalCompositeOperation = 'multiply';
          g.fillStyle = '#3B2414'; g.fillText(line, 0, ly);
          g.globalCompositeOperation = 'source-over';
          g.fillStyle = 'rgba(30,16,6,.35)'; g.fillText(line, 0, ly);
        }
      });
      g.restore();
    }

    let lb = null;
    function render() {
      if (canvas && stage) draw(canvas, stage.clientWidth || root.clientWidth);
      if (lb && !lb.hidden) draw(lb.querySelector('canvas'), lb.querySelector('.sa-p-lbin, .sa-lb__in').clientWidth);
    }
    function loadFont(f) {
      const spec = (f.italic ? 'italic ' : '') + (f.weight || 400) + ' 40px ' + f.css;
      if (document.fonts && document.fonts.load) document.fonts.load(spec, 'Olivia').then(render, render); else render();
    }

    if (stage) {
      lb = document.createElement('div');
      lb.className = 'sa-lb';
      lb.hidden = true;
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<div class="sa-lb__in"><canvas></canvas><button type="button" class="sa-lb__close" aria-label="' + esc(t('close')) + '">×</button></div>';
      document.body.appendChild(lb);
      const closeLb = () => { lb.hidden = true; document.documentElement.style.overflow = ''; stage.focus(); };
      stage.addEventListener('click', () => {
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(render);
        lb.querySelector('.sa-lb__close').focus();
      });
      lb.querySelector('.sa-lb__close').addEventListener('click', (e) => { e.stopPropagation(); closeLb(); });
      lb.addEventListener('click', (e) => { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
      if (window.ResizeObserver) new ResizeObserver(() => render()).observe(stage);
    }

    /* ---- text inputs ---- */
    function setCount(el, n) {
      el.textContent = n + '/' + limit;
      el.className = 'sa-p__count' + (n >= limit ? ' sa-p__count--full' : n >= limit - 4 ? ' sa-p__count--near' : '');
    }
    if (lines) {
      const wrap = $('[data-sa-lines]');
      for (let i = 0; i < lines; i++) {
        const box = document.createElement('div');
        box.className = 'sa-p__inwrap';
        const inp = document.createElement('input');
        inp.className = 'sa-p__input';
        inp.type = 'text';
        inp.autocomplete = 'off';
        inp.spellcheck = false;
        inp.setAttribute('autocapitalize', 'words');
        inp.setAttribute('enterkeyhint', i < lines - 1 ? 'next' : 'done');
        inp.placeholder = lines === 1 ? t('placeholder') : t('ph' + (i + 1));
        inp.setAttribute('aria-label', lines === 1 ? t('engraving') : t('engraving') + ' – ' + t('line') + ' ' + (i + 1));
        const cnt = document.createElement('span');
        cnt.className = 'sa-p__count';
        cnt.setAttribute('aria-live', 'polite');
        setCount(cnt, 0);
        inp.addEventListener('input', () => {
          const pos = inp.selectionStart;
          const before = inp.value;
          const r = sanitize(before, limit);
          if (r.out !== before) {
            inp.value = r.out;
            const p = Math.max(0, pos - (before.length - r.out.length));
            try { inp.setSelectionRange(p, p); } catch (e) {}
          }
          st.texts[i] = r.out;
          if (r.removed) flash(t('allowed'));
          else if (r.cut || Array.from(r.out).length >= limit) flash(t('limit').replace('{n}', limit), 2400);
          setCount(cnt, Array.from(r.out).length);
          setProps();
          render();
        });
        inp.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const nx = wrap.querySelectorAll('input')[i + 1];
            if (nx) nx.focus(); else inp.blur();
          }
        });
        box.appendChild(inp);
        box.appendChild(cnt);
        wrap.appendChild(box);
      }
    }

    /* ---- font dropdown (GGS) ---- */
    const fontField = $('[data-sa-fontfield]');
    if (fontField) {
      const btn = $('[data-sa-fontbtn]');
      const val = $('[data-sa-fontval]');
      const list = $('[data-sa-fontlist]');
      let kb = 0;
      const showVal = () => { val.textContent = st.font.name; val.style.fontFamily = st.font.css; val.style.fontWeight = st.font.weight; val.style.fontStyle = st.font.italic ? 'italic' : 'normal'; };
      const hover = (i) => { if (!pv) return; const keep = st.font; st.font = FONTS[i]; render(); st.font = keep; };
      const build = () => {
        list.innerHTML = '';
        FONTS.forEach((f, i) => {
          const li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.id = uid + '-fo' + i;
          li.textContent = f.name;
          li.style.fontFamily = f.css;
          li.style.fontWeight = f.weight;
          li.style.fontStyle = f.italic ? 'italic' : 'normal';
          li.setAttribute('aria-selected', String(st.font === f));
          li.addEventListener('click', () => choose(i));
          li.addEventListener('mouseenter', () => hover(i));
          list.appendChild(li);
        });
      };
      const mark = () => {
        Array.prototype.forEach.call(list.children, (li, i) => li.classList.toggle('is-kb', i === kb));
        const cur = list.children[kb];
        if (cur) { cur.scrollIntoView({ block: 'nearest' }); list.setAttribute('aria-activedescendant', cur.id); }
      };
      const open = (o) => {
        list.hidden = !o;
        btn.setAttribute('aria-expanded', String(o));
        if (o) { kb = FONTS.indexOf(st.font); mark(); list.focus({ preventScroll: true }); } else render();
      };
      const choose = (i) => { st.font = FONTS[i]; showVal(); build(); open(false); btn.focus(); setProps(); loadFont(st.font); };
      btn.addEventListener('click', () => open(list.hidden));
      list.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') { kb = Math.min(FONTS.length - 1, kb + 1); mark(); hover(kb); e.preventDefault(); }
        else if (e.key === 'ArrowUp') { kb = Math.max(0, kb - 1); mark(); hover(kb); e.preventDefault(); }
        else if (e.key === 'Enter' || e.key === ' ') { choose(kb); e.preventDefault(); }
        else if (e.key === 'Escape' || e.key === 'Tab') { open(false); btn.focus(); }
      });
      document.addEventListener('pointerdown', (e) => { if (!list.hidden && !fontField.contains(e.target)) open(false); });
      showVal();
      build();
    }

    /* ---- packaging ---- */
    const opts = root.querySelectorAll('[data-sa-pack]');
    opts.forEach((b) => b.addEventListener('click', () => {
      st.pack = b.dataset.saPack;
      opts.forEach((o) => o.setAttribute('aria-checked', String(o === b)));
      setProps();
    }));
    const group = root.querySelector('.sa-p__opts');
    if (group) group.addEventListener('keydown', (e) => {
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
      const arr = Array.prototype.slice.call(opts);
      const i = arr.findIndex((o) => o.getAttribute('aria-checked') === 'true');
      const n = arr[(i + 1) % arr.length];
      n.click(); n.focus(); e.preventDefault();
    });

    /* ---- place the block right above the buy buttons ---- */
    const holder = document.createElement('div');
    holder.className = 'product-info__block-item';
    holder.setAttribute('data-block-type', 'sa-personalisierung');
    target.parentNode.insertBefore(holder, target);
    holder.appendChild(root);
    root.hidden = false;

    setProps();
    if (pv) {
      loadFont(currentFont());
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
    }
  }

  function boot() {
    document.querySelectorAll('[data-sa-p]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();